import { operators as o } from '@pendo/aggregations';
import { DxEventType } from '@/types/analytics/data-explorer.types';
import { EventName } from '@/types/analytics/analytics.types';

const eventTypeConfig: { [key in EventName]: DxEventType } = {
    [EventName.Page]: {
        name: EventName.Page,
        label: 'Page views',
        timestampLabel: 'day',
        moduleName: 'pages',
        sourceType: 'page',
        sourceEvents: 'pageEvents',
        sourceId: 'pageId',
        supplementalFilters: [],
    },
    [EventName.Feature]: {
        name: EventName.Feature,
        label: 'Feature clicks',
        timestampLabel: 'day',
        moduleName: 'features',
        sourceType: 'feature',
        sourceEvents: 'featureEvents',
        sourceId: 'featureId',
        supplementalFilters: [],
    },
    [EventName.TrackEvent]: {
        name: EventName.TrackEvent,
        label: 'Track Events',
        timestampLabel: 'day',
        moduleName: 'trackTypes',
        sourceType: 'trackEvent',
        sourceEvents: 'trackEvents',
        sourceId: 'trackTypeId',
        supplementalFilters: [],
    },
    [EventName.Guide]: {
        name: EventName.Guide,
        label: 'guide views',
        title: 'Guide views',
        timestampLabel: 'browserTime',
        moduleName: 'guides',
        sourceType: 'guide',
        sourceEvents: 'guideEvents',
        sourceId: 'guideId',
        supplementalFilters: [
            o.merge(
                ['guideId'],
                o.mappings({
                    guideId: 'id',
                }),
                o.pipeline(o.sources.guides({ appId: 'expandAppIds("*")' })),
            ),
            o.filter('guideSeenReason!="continue" && eventSubType(type)=="guideSeen"'),
            o.evalExpression({ numEvents: '1' }),
        ],
    },
    [EventName.App]: {
        isAnyActivity: true,
        name: EventName.App,
        label: 'events',
        title: 'Any activity',
        timestampLabel: 'day',
        moduleName: 'apps',
        sourceType: 'app',
        sourceEvents: 'events',
        sourceId: 'appId',
        supplementalFilters: [],
    },
    [EventName.AIAgent]: {
        name: EventName.AIAgent,
        label: 'AI Agent Interactions',
        timestampLabel: 'day',
        moduleName: 'aiAgents',
        sourceType: 'aiAgent',
        sourceEvents: 'aiAgentInteractions',
        sourceId: 'aiAgentId',
        supplementalFilters: [],
    },
};

export default eventTypeConfig;
